import {MenuItem} from '@material-ui/core';
import React from 'react';
import {useHistory} from 'react-router-dom';
import {PaymentActionType} from './PaymentActionHelper';

const PaymentDetailsAction = React.forwardRef(({ payment, setMenuAnchor, label }: PaymentActionType, ref: React.Ref<any>) => {
  let history = useHistory();
  return (
    <MenuItem
      ref={ref}
      key={payment.id + 'details'}
      onClick={() => {
        setMenuAnchor(null);
        history.push(`/dashboard/transactions/payments/${payment.id}/`);
      }}
    >
      {label}
    </MenuItem>
  );
});

export default PaymentDetailsAction;
